/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable react/prop-types */
/* eslint-disable no-undef */
import {
  createContext,
  useContext,
  useEffect,
  useReducer
} from "react"
import { ACCOUNT_INITIALISE, LOGIN, LOGOUT } from "../store/actions"
import accountReducer from "../store/accountReducer"
import Loader from "../components/Loader/Loader"
import useAxiosPrivate from "../hooks/useAxiosPrivate"
import { ConfigContext } from "./ConfigContext"
import * as actionType from "../store/actions"
import {
  getTenantName,
  getToken,
  setTenantName,
  setToken
} from "../assets/js/features/token/TokenEncryption"
import { setUserPermission, setUserLocalization } from "../assets/js/app/state/appSessionStorage"
import { BASE_DOMAIN, WEBPORTAL_URL } from "../api/axios"
import { APIROUTES } from "../routes/APIRoutes"

const initialState = {
  isLoggedIn: false,
  isInitialised: false,
  user: null
}

export const setSession = (serviceToken, tenantName = null) => {
  if (serviceToken) {
    setToken(serviceToken)
  } else {
    if (tenantName) {
      sessionStorage.removeItem('email');
      sessionStorage.removeItem('serviceToken');
      sessionStorage.removeItem('userPermission');
      sessionStorage.removeItem('userInfo');
      sessionStorage.removeItem('userLocalization');
      sessionStorage.removeItem('tenantType');
    } else {
      sessionStorage.clear();
    }
  }
}

const JWTContext = createContext({
  ...initialState,
  login: (email, password) => Promise.resolve(),
  logout: () => {}
})

export const JWTProvider = ({ children }) => {
  const axiosPrivate = useAxiosPrivate()
  const [state, dispatch] = useReducer(accountReducer, initialState)
  const url =
    `${BASE_DOMAIN}/ether/cms/api/v1/auth/login_validate`

  const configContext = useContext(ConfigContext)
  const { dispatch: d } = configContext

  const login = async (email, password) => {
    try {
      const data = { usernameOrEmail: email,
        password: password }
      const config = {
        headers: { "Content-Type": "application/json" }
      }

      const response = await axiosPrivate.post(url, data, config)
      const { accessToken } = response.data
      if (response?.status === 200) {
        sessionStorage.setItem("email", email)
        setSession(accessToken)
        await getTenantTypeLocalization()        
        await getUserPermission()
        dispatch({
          type: LOGIN,
          payload: {
            user: email
          }
        })
        d({
          type: actionType.TOKEN,
          token: accessToken
        })
      }
      return { status: 200 }
    } catch (err) {
      const status = err?.response?.status
      return { status: status }
    }
    // dispatch({
    //   type: LOGIN,
    //   payload: {
    //     id: 1,
    //     email: "xya@qwe.com"
    //   }
    // })
  }

  const getTenantTypeLocalization = async () => {

    try {
      const response = await axiosPrivate.get("rest/get_user_localization")
      //code here to add localization key value data
      setUserLocalization(response.data)
      return response.data
    } catch (err) {
      console.log(err)
      const status = err?.response?.status
      return { status: status }
    }
  }
  


  const getUserPermission = async () => {
    try {
      const response = await axiosPrivate.get("rest/get_user_permissions")
      // sessionStorage.setItem("userPermission", JSON.stringify(response.data))
      setUserPermission(response.data);
      return response.data
    } catch (err) {
      const status = err?.response?.status
      return { status: status }
    }
  }

  const logout = () => {
    const tenantName = getTenantName();
    setSession(null, tenantName);
    setTenantName(tenantName);
    dispatch({ type: LOGOUT })
  }

  useEffect(() => {
    const init = async () => {
      try {
        const serviceToken = getToken()
        if (serviceToken) {
          setSession(serviceToken)
          dispatch({
            type: ACCOUNT_INITIALISE,
            payload: {
              isLoggedIn: true,
              user: sessionStorage.getItem("email")
            }
          })
        } else {
          dispatch({
            type: ACCOUNT_INITIALISE,
            payload: {
              isLoggedIn: false
            }
          })
        }
      } catch (err) {
        console.error(err)
        dispatch({
          type: ACCOUNT_INITIALISE,
          payload: {
            isLoggedIn: false,
            user: null
          }
        })
      }
    }

    init()
  }, [])

  if (!state.isInitialised) {
    return <Loader />
  }

  return (
    <JWTContext.Provider value={{ ...state,
      login,
      logout,
      getUserPermission }}>
      {children}
    </JWTContext.Provider>
  )
}

export default JWTContext
